import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthStore } from '../components/authStore';
import { useUserStore } from '../components/userStore';

const Logout = () => {
	const { signOut } = useAuthStore();
	const { updateUser } = useUserStore();
	const navigate = useNavigate();

	useEffect(() => {
		signOut();
		updateUser(null);
		navigate('/', { replace: true });
	}, []);

	return null;
};

export default Logout;
